var _defs, _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnteciparParcelas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "218.37 212.214 89.073 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23893_5379",
    x: -3,
    y: 4,
    width: 103.938,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.14902 0 0 0 0 0.145098 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23893_5379"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23893_5379",
    result: "shape"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 226.44 222.394 C 223.811 222.394 221.68 224.401 221.68 226.875 L 218.37 295.734 C 218.37 298.208 220.501 300.214 223.13 300.214 L 302.682 300.214 C 305.311 300.214 307.443 298.208 307.443 295.734 L 303.186 216.695 C 303.186 214.22 301.054 212.214 298.425 212.214 L 226.44 222.394 Z",
    fill: "#F7F5F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23893_5379)",
    transform: "matrix(1, 0, 0, 1, 214.3697052001953, 212.2141418457031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5485 35.3878L53.8584 74.3927C53.4765 75.0833 52.8467 75.6033 52.0962 75.8473C51.3457 76.0914 50.5306 76.0415 49.8155 75.7076L22.7982 63.219C22.4017 63.0341 22.0486 62.7678 21.7619 62.4374C21.4752 62.1069 21.2613 61.7197 21.1343 61.3011C21.0072 60.8825 20.9697 60.4418 21.0244 60.0077C21.079 59.5737 21.2245 59.156 21.4513 58.7819L44.0674 21.4982C44.4502 20.8692 45.043 20.3959 45.7411 20.1618C46.4392 19.9278 47.1976 19.9482 47.8822 20.2193L74.9733 30.9868C75.3847 31.1503 75.7558 31.3995 76.0629 31.7178C76.3709 32.036 76.6062 32.416 76.7554 32.8325C76.9046 33.249 76.963 33.6925 76.9275 34.1334C76.892 34.5744 76.7625 35.0027 76.5485 35.3898",
    fill: "#D7D8D6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.324 245.795 L 280.995 256.848 C 281.976 257.271 282.873 256.964 283.397 256.034 L 286.089 251.431 C 286.69 250.346 286.209 249.385 285.064 248.901 L 260.475 237.911 C 260.017 237.718 259.505 237.694 259.031 237.844 C 258.558 237.995 258.153 238.31 257.891 238.732 L 255.377 242.777 C 255.218 243.032 255.116 243.318 255.078 243.616 C 255.04 243.914 255.067 244.217 255.157 244.503 C 255.247 244.79 255.397 245.054 255.599 245.277 C 255.8 245.5 256.048 245.676 256.324 245.795 Z",
    fill: "#01BA61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 242.297 268.901 L 267.655 280.403 C 268.628 280.841 269.368 280.467 269.905 279.542 L 272.489 275.221 C 273.111 274.148 272.933 273.031 271.798 272.529 L 246.58 261.085 C 245.641 260.671 244.743 261.003 244.178 261.866 L 241.599 265.869 C 240.908 266.939 241.128 268.37 242.291 268.895",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 249.002 257.211 L 274.36 268.714 C 275.335 269.153 276.074 268.777 276.61 267.854 L 279.194 263.533 C 279.816 262.458 279.64 261.343 278.505 260.841 L 253.287 249.397 C 252.349 248.981 251.45 249.315 250.886 250.178 L 248.304 254.181 C 247.613 255.257 247.839 256.688 249.002 257.211 Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnteciparParcelas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/antecipar_parcelas.985d02cdf84a3eb6c699929ca15763c8.svg";